import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";
import initI18n from "./scripts/i18n";
import initVisitStats from "./scripts/visitStats";
import initHeroContactForm from "./scripts/heroContactForm";

// 初始化多语言（必须在其他模块之前）
initI18n();

// 等待 DOM 和 i18n 初始化完成
document.addEventListener('DOMContentLoaded', () => {
  // 延迟一点确保 i18n 已经更新了页面
  setTimeout(() => {
    initScrollReveal(targetElements, defaultProps);
    initTiltEffect();
    initVisitStats();
    initHeroContactForm();
  }, 100);
});

// 如果 DOM 已经加载完成
if (document.readyState !== 'loading') {
  setTimeout(() => {
    initScrollReveal(targetElements, defaultProps);
    initTiltEffect();
    initVisitStats();
    initHeroContactForm();
  }, 100);
}
